import { upsertAiChatLimit, upsertProfile } from "@/api/fetch";
import { useRootStore } from "@/state/RootStore";
import { StorageKeys } from "@/utils/storage";
import { useNavigate } from "react-router";
import { ChevronRight, Wrench } from "lucide-react";

interface AdminModeProps {
  variant?: "default" | "settings";
}

const AdminMode = ({ variant = "default" }: AdminModeProps) => {
  const navigate = useNavigate();
  const store = useRootStore();

  const adminFeatures = [
    {
      label: `Change Force Purchase State`,
      action: async () => {
        navigate("/force-purchase-state");
      },
    },
    {
      label: "Delete Profile",
      action: async () => {
        await store.mainAppStore.resetProfile();
        navigate("/profile");
        alert("Deleted Profile!");
      },
    },
    {
      label: "Delete All Tests",
      action: async () => {
        store.testStore.deleteAllTests();
        alert("Deleted!");
      },
    },
    {
      label: "Reset Quick Practice Day",
      action: () => {
        store.testStore.resetQuickPracticeCount();
        alert("Reset!");
      },
    },
    {
      label: "Reset Codebook Day",
      action: () => {
        store.testStore.resetCodebookCount();
        alert("Reset!");
      },
    },
    {
      label: "Reset State Selection",
      action: () => {
        store.mainAppStore.resetSelectedStateCode();
        alert("Reset!");
      },
    },
    {
      label: "Reset Coachmarks",
      action: async () => {
        await upsertProfile({ have_shown_coachmark: false });
        store.mainAppStore.showCoachmark = true;
        alert("Reset!");
      },
    },
    {
      label: "Reset AI Free Trial",
      action: async () => {
        const now = new Date();
        const today = now.toISOString().split("T")[0];
        const thisMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
        const thisYear = String(now.getFullYear());
        const data = {
          day: { date: today, count: 0 },
          month: { date: thisMonth, count: 0 },
          year: { date: thisYear, count: 0 },
        };
        await upsertAiChatLimit(data);
        localStorage.removeItem(StorageKeys.MESSAGE_LIMIT_KEY);
        alert("Reset!");
      },
    },
  ];

  if (variant === "settings") {
    return (
      <>
        {adminFeatures.map((feature) => (
          <button
            type="button"
            onClick={() => void feature.action()}
            key={feature.label}
            className="flex min-h-[72px] w-full items-center gap-4 px-6 text-left transition-colors hover:bg-[#fafafa] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[var(--dp-brand-button)]"
          >
            <Wrench aria-hidden="true" className="h-5 w-5 shrink-0 text-[#5b616d]" />
            <span className="min-w-0 flex-1 text-base font-medium leading-6 text-[#0a0c11]">{feature.label}</span>
            <ChevronRight aria-hidden="true" className="h-5 w-5 shrink-0 text-[#5b616d]" />
          </button>
        ))}
      </>
    );
  }

  return (
    <div className="flex flex-col gap-4">
      {adminFeatures.map((feature) => (
        <button
          onClick={() => void feature.action()}
          key={feature.label}
          className="dp-button-primary w-full py-4 disabled:bg-gray-100 disabled:text-gray-500"
        >
          {feature.label}
        </button>
      ))}
    </div>
  );
};

export default AdminMode;
